<template>
  <div class="drag-container" ref="container">
    <div class="element" @mousedown.stop="startDrag" ref="element">
      <div class="block-1 block block-top"></div>
      <div class="block-2 block block-top"></div>
      <div class="block-3 block block-top"></div>
      <div class="block-1 block block-bottom"></div>
      <div class="block-2 block block-bottom"></div>
      <div class="block-3 block block-bottom"></div>
      <div class="line-1-1"></div>
      <div class="line-1-1"></div>
      <div class="line-1-2"></div>
      <div class="line-2-1"></div>
      <div class="line-2-2"></div>
      <div class="line-2-3"></div>
    </div>
    <div
      class="bg"
      :style="{
        'background-image': `url(${template})`,
        height: height + 'px',
        width: width + 'px'
      }"
    ></div>
  </div>
</template>
<script>
import _ from 'lodash';
import {
  img_1,
  img_2,
  img_3,
  img_4,
  img_5,
  img_6,
  img_7,
  img_8,
  img_9,
  img_10,
  img_11,
  img_12,
  img_13
} from '../assets/images/template';
export default {
  name: 'TemplateDrag',
  data() {
    return {
      templateList: [
        img_1,
        img_2,
        img_3,
        img_4,
        img_5,
        img_6,
        img_7,
        img_8,
        img_9,
        img_10,
        img_11,
        img_12,
        img_13
      ],
      template: '',
      width: 400,
      height: 200
    };
  },
  mounted() {
    this.getTemplate(this.width, this.height);
  },
  methods: {
    startDrag(e) {
      e.stopPropagation();
      let element = this.$refs.element;
      let CENTER = {};
      CENTER.x = this.getOffsetLeft(element) + element.offsetWidth / 2;
      CENTER.y = this.getOffsetTop(element) + element.offsetHeight / 2;
      let width = null;
      let height = null;
      document.onmousemove = e => {
        width = Math.abs(e.x - CENTER.x) * 2;
        height = Math.abs(e.y - CENTER.y) * 2;
        element.style.width = width + 'px';
        element.style.height = height + 'px';
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
        this.getTemplate(width, height);
      };
    },
    getOffsetTop(el) {
      return el.offsetParent
        ? el.offsetTop + this.getOffsetTop(el.offsetParent)
        : el.offsetTop;
    },
    getOffsetLeft(el) {
      return el.offsetParent
        ? el.offsetLeft + this.getOffsetLeft(el.offsetParent)
        : el.offsetLeft;
    },
    getTemplate(width, height) {
      if (width > 600) {
        width = 600;
      } else if (width < 200) {
        width = 200;
      }
      if (height > 400) {
        height = 400;
      } else if (height < 200) {
        height = 200;
      }
      this.width = width;
      this.height = height;
      let arr = this.templateList.map((item, index) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = item;
          img.onload = function() {
            resolve({ src: item, width: img.width, height: img.height });
          };
        });
      });
      Promise.all(arr).then(resolve => {
        let arrS = _.sortBy(resolve, function(o) {
          return Math.abs(o.width / o.height - width / height);
        });
        let result = arrS[0];
        this.template = result.src;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.drag-container {
  width: 600px;
  height: 400px;
  margin-top: 60px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .element {
    position: absolute;
    width: 400px;
    height: 200px;
    min-width: 200px;
    min-height: 200px;
    max-width: 100%;
    max-height: 100%;
    border: solid 1px #83b1cd;
    .block {
      width: 10px;
      height: 10px;
      position: absolute;
      background: #fff;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
      cursor: pointer;
      z-index: 2;
    }
    .block-top {
      top: -5px;
    }
    .block-bottom {
      bottom: -5px;
    }
    .block-1 {
      left: -5px;
    }
    .block-3 {
      right: -5px;
    }
    .block-2 {
      left: calc(50% - 5px);
    }
    .line-1-1 {
      position: absolute;
      width: 100%;
      height: 1px;
      background: #83b1cd;
      left: 0;
      top: 33.3%;
    }
    .line-1-2 {
      position: absolute;
      width: 100%;
      height: 1px;
      background: #83b1cd;
      left: 0;
      top: 66.6%;
    }
    .line-2-1 {
      position: absolute;
      width: 1px;
      height: 100%;
      background: #83b1cd;
      left: 25%;
      top: 0;
    }
    .line-2-2 {
      position: absolute;
      width: 1px;
      height: 100%;
      background: #83b1cd;
      left: 50%;
      top: 0;
    }
    .line-2-3 {
      position: absolute;
      width: 1px;
      height: 100%;
      background: #83b1cd;
      left: 75%;
      top: 0;
    }
  }
  .bg {
    width: 400px;
    height: 200px;
    min-width: 200px;
    min-height: 200px;
    max-width: 100%;
    max-height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
